import mapExchangeRates, { RawExchangeRates } from './mapExchangeRates';
import mapSystemModule, { RawSystemModule } from './mapSystemModule';
import mapUserProductGroupNotification, { RawNotification } from './mapUserProductGroupNotification';
import UserProductGroup from './UserProductGroup';
import UserProductGroupParent from './UserProductGroupParent';

export interface RawUserProductGroup {
	id: string;
	name: string;
	productsCount: number;
	productGroupsCount: number;
	itemsUpdatedTime: Date;
	notification: RawNotification;
	type: string;
	systemModule: RawSystemModule | null;
	parent: UserProductGroupParent | null;
	exchangeRates: RawExchangeRates;
	historicProductDataViewDate: string | null;
	_links: { [key: string]: string | undefined };
}

export default function mapUserProductGroup(group: RawUserProductGroup): UserProductGroup {
	return new UserProductGroup(
		group.id,
		group.name,
		group.productsCount,
		group.productGroupsCount,
		new Date(group.itemsUpdatedTime),
		mapUserProductGroupNotification(group.notification),
		group.type,
		group.systemModule !== null ? mapSystemModule(group.systemModule) : null,
		group.parent !== null
			? new UserProductGroupParent(group.parent.id, group.parent.name, group.parent.productGroupsCount)
			: null,
		mapExchangeRates(group.exchangeRates),
		group.historicProductDataViewDate !== null ? new Date(group.historicProductDataViewDate) : null,
		group._links
	);
}
